import React, { useState } from 'react';
import { useI18n } from '../context/I18nContext';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import api from '../services/api';
import { TrashIcon, AlertIcon, CheckIcon } from '../components/Icons';

const DataDeletion = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const { t } = useI18n();
  const [step, setStep] = useState(1);
  const [confirmText, setConfirmText] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const handleRequestDeletion = async (e) => {
    e.preventDefault();
    setError('');

    if (confirmText !== t('datadeleti.a1')) {
      setError(t('datadeleti.a2'));
      return;
    }

    if (!password) {
      setError(t('del.typePassword'));
      return;
    }

    setLoading(true);

    try {
      await api.post('/users/request-deletion', { password });
      setSuccess(true);

      // Aguarda 3 segundos e faz logout
      setTimeout(() => {
        logout();
        navigate('/');
      }, 5000);
    } catch (err) {
      setError(err.response?.data?.error || t('datadeleti.a3'));
    }

    setLoading(false);
  };

  if (success) {
    return (
      <div className="p-8">
        <div className="max-w-2xl mx-auto">
          <div className="bg-green-50 border border-green-200 rounded-2xl p-8 text-center">
            <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <CheckIcon className="w-8 h-8 text-green-600" />
            </div>
            <h2 className="text-2xl font-bold text-green-800 mb-2">
              Solicitacao Processada
            </h2>
            <p className="text-green-700 mb-4">{t('datadeleti.j1')}</p>
            <p className="text-sm text-green-600">{t('datadeleti.j2')}</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="p-8">
      <div className="max-w-2xl mx-auto">
        <div className="mb-8">
          <h1 className="text-2xl font-bold text-gray-900 mb-2">{t('del.title')}</h1>
          <p className="text-gray-600">{t('datadeleti.j3')}</p>
        </div>

        {/* Aviso */}
        <div className="bg-red-50 border border-red-200 rounded-2xl p-6 mb-8">
          <div className="flex items-start gap-4">
            <div className="w-12 h-12 bg-red-100 rounded-xl flex items-center justify-center flex-shrink-0">
              <AlertIcon className="w-6 h-6 text-red-600" />
            </div>
            <div>
              <h3 className="text-lg font-semibold text-red-800 mb-2">{t('datadeleti.j4')}</h3>
              <p className="text-red-700 text-sm mb-3">{t('datadeleti.j5')}</p>
              <ul className="text-red-700 text-sm space-y-1 list-disc list-inside">
                <li>{t('del.personalData')}</li>
                <li>{t('del.apiConnections')}</li>
                <li>{t('del.messageHistory')}</li>
                <li>{t('del.settings')}</li>
                <li>{t('del.metaStored')}</li>
              </ul>
            </div>
          </div>
        </div>

        {/* Formulario */}
        <div className="bg-white rounded-2xl p-8 shadow-sm border border-gray-100">
          <h3 className="text-lg font-semibold text-gray-900 mb-6">{t('datadeleti.j6')}</h3>

          {error && (
            <div className="mb-6 p-4 bg-red-50 border border-red-200 rounded-xl text-red-700 text-sm">
              {error}
            </div>
          )}

          <form onSubmit={handleRequestDeletion} className="space-y-6">
            <div>
              <label className="block text-sm font-medium text-gray-900 mb-2">{t('datadeleti.j7')}</label>
              <input
                type="email"
                value={user?.email || ''}
                disabled
                className="w-full h-12 px-4 bg-gray-100 rounded-lg text-gray-600 cursor-not-allowed"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-900 mb-2">{t('del.typePassword')}</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder={t('del.currentPassword')}
                className="w-full h-12 px-4 bg-gray-50 rounded-lg border border-gray-200 focus:ring-2 focus:ring-red-500 focus:border-red-500 outline-none"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-900 mb-2">{t('datadeleti.j8')}<span className="font-bold text-red-600">{t('del.confirmButton')}</span>{t('datadeleti.j9')}</label>
              <input
                type="text"
                value={confirmText}
                onChange={(e) => setConfirmText(e.target.value)}
                placeholder={t('del.confirmButton')}
                className="w-full h-12 px-4 bg-gray-50 rounded-lg border border-gray-200 focus:ring-2 focus:ring-red-500 focus:border-red-500 outline-none"
              />
            </div>

            <div className="pt-4 border-t border-gray-100">
              <button
                type="submit"
                disabled={loading || confirmText !== t('datadeleti.a4') || !password}
                className="w-full flex items-center justify-center gap-2 h-12 bg-red-600 text-white font-semibold rounded-xl hover:bg-red-700 disabled:opacity-50 disabled:cursor-not-allowed transition-all"
              >
                {loading ? (
                  <>
                    <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                    <span>{t('del.processing')}</span>
                  </>
                ) : (
                  <>
                    <TrashIcon className="w-5 h-5" />
                    <span>{t('del.request')}</span>
                  </>
                )}
              </button>
            </div>
          </form>

          <div className="mt-6 pt-6 border-t border-gray-100">
            <p className="text-xs text-gray-500 text-center">{t('datadeleti.j10')}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DataDeletion;
